import { createContext, useContext, type PropsWithChildren } from "react";
import type { QuickActionSource } from "./types";

const AnalyticsSourceContext = createContext<QuickActionSource | null>(null);

/**
 * Declares the surface that customer-action events fired inside this subtree are attributed to.
 * Mount once per page; `useAnalyticsSource` reads it where the event fires, so intermediate
 * components carry no tracking props.
 */
export function AnalyticsSourceScope({ source, children }: PropsWithChildren<{ source: QuickActionSource }>) {
  return <AnalyticsSourceContext.Provider value={source}>{children}</AnalyticsSourceContext.Provider>;
}

export function useAnalyticsSource(): QuickActionSource {
  const source = useContext(AnalyticsSourceContext);
  if (!source) {
    throw new Error("useAnalyticsSource must be used within an AnalyticsSourceScope");
  }
  return source;
}
